<template>
  <main class="c-main">
    <div class="row">
      <div class="col-md-12">
        <div class="card m-0">
          <header class="card-header">
            <a
              @click="changeModel('categorie')"
              :class="{ active: filter.model === 'categorie' }"
              class="btn btn-success"
            >
              Категории
            </a>
            <a
              @click="changeModel('product')"
              :class="{ active: filter.model === 'product' }"
              class="btn btn-success ml-2"
            >
              Классы
            </a>
            <a
              @click="changeModel('field')"
              :class="{ active: filter.model === 'field' }"
              class="btn btn-success ml-2"
            >
              Свойства
            </a>
            <a
              @click="changeModel('field_value')"
              :class="{ active: filter.model === 'field_value' }"
              class="btn btn-success ml-2"
            >
              Значение свойства
            </a>
            <div class="pull-right">
              <h4 style="display: inline-block">Переводы</h4>
            </div>
          </header>
          <div class="card-body">
            <div>
              <!-- Using modifiers -->
              <b-button v-b-toggle.filter class="m-1">Filter</b-button>
              <b-button v-b-toggle.pagination class="m-1">Pagination</b-button>

              <!-- Element to collapse -->
              <b-collapse id="filter">
                <b-card>
                  <b-form-group
                    class="d-inline mr-3 border p-2"
                    label="пассивность"
                    v-slot="{ ariaDescribedby }"
                  >
                    <b-form-radio
                      @change="getTranslation()"
                      v-model="filter.passive"
                      :aria-describedby="ariaDescribedby"
                      name="passive-0-radios"
                      value="0"
                      >Без пассивными
                    </b-form-radio>
                    <b-form-radio
                      @change="getTranslation()"
                      v-model="filter.passive"
                      :aria-describedby="ariaDescribedby"
                      name="passive-1-radios"
                      value="1"
                      >С пассивными
                    </b-form-radio>
                  </b-form-group>

                  <b-form-group
                    class="d-inline mr-3 border p-2"
                    label="Полностью переведен"
                    v-slot="{ ariaDescribedby }"
                  >
                    <b-form-radio
                      @change="getTranslation()"
                      v-model="filter.not_complete"
                      :aria-describedby="ariaDescribedby"
                      name="not_complete-0-radios"
                      value="0"
                      >Нет
                    </b-form-radio>
                    <b-form-radio
                      @change="getTranslation()"
                      v-model="filter.not_complete"
                      :aria-describedby="ariaDescribedby"
                      name="not_complete-1-radios"
                      value="1"
                      >Да
                    </b-form-radio>
                  </b-form-group>

                  <b-form-group
                    class="d-inline mr-3 border p-2"
                    label="переводы"
                    v-slot="{ ariaDescribedby }"
                  >
                    <b-form-radio
                      @change="getTranslation()"
                      v-model="filter.translated"
                      :aria-describedby="ariaDescribedby"
                      name="translated-0-radios"
                      value="0"
                      >Без переведенных</b-form-radio
                    >
                    <b-form-radio
                      @change="getTranslation()"
                      v-model="filter.translated"
                      :aria-describedby="ariaDescribedby"
                      name="translated-1-radios"
                      value="1"
                      >С переведенными</b-form-radio
                    >
                  </b-form-group>
                  <b-form-group
                    class="d-inline mr-3 border p-2"
                    label="популярность"
                    v-slot="{ ariaDescribedby }"
                  >
                    <b-form-radio
                      @change="getTranslation()"
                      v-model="filter.popularity"
                      :aria-describedby="ariaDescribedby"
                      name="popularity-0-radios"
                      value="0"
                      >Не учитывать</b-form-radio
                    >
                    <b-form-radio
                      @change="getTranslation()"
                      v-model="filter.popularity"
                      :aria-describedby="ariaDescribedby"
                      name="popularity-1-radios"
                      value="1"
                      >Учитывать</b-form-radio
                    >
                  </b-form-group>
                  <b-form-group
                    class="d-inline mr-3 border p-2"
                    label="классы с не полным переводом"
                    v-slot="{ ariaDescribedby }"
                  >
                    <b-form-radio
                      @change="getTranslation()"
                      v-model="filter.fully_translated"
                      :aria-describedby="ariaDescribedby"
                      name="fully_translated-0-radios"
                      value="0"
                      >Не учитывать</b-form-radio
                    >
                    <b-form-radio
                      @change="getTranslation()"
                      v-model="filter.fully_translated"
                      :aria-describedby="ariaDescribedby"
                      name="fully_translated-1-radios"
                      value="1"
                      >Учитывать</b-form-radio
                    >
                  </b-form-group>
                </b-card>
              </b-collapse>
              <!-- Element to collapse -->
              <b-collapse id="pagination">
                <b-card>
                  <b-form-group
                    class="d-inline mr-3 border p-2"
                    label="Поиск"
                    v-slot="{ ariaDescribedby }"
                  >
                    <b-form-input
                      class="p-1"
                      @change="getTranslation()"
                      v-model="filter.search_title"
                      placeholder="Search..."
                      :aria-describedby="ariaDescribedby"
                      id="search_title"
                    />
                  </b-form-group>
                  <b-form-group
                    class="d-inline mr-3 border p-2"
                    label="Количество"
                    v-slot="{ ariaDescribedby }"
                  >
                    <b-form-input
                      @change="getTranslation()"
                      type="number"
                      v-model.number="filter.per_page"
                      :aria-describedby="ariaDescribedby"
                      id="per_page"
                    />
                  </b-form-group>
                  <b-form-group
                    class="d-inline mr-3 border p-2"
                    label="Страница"
                    v-slot="{ ariaDescribedby }"
                  >
                    <b-form-input
                      @change="getTranslation()"
                      type="number"
                      v-model.number="filter.page"
                      :aria-describedby="ariaDescribedby"
                      id="page"
                    />
                  </b-form-group>
                </b-card>
              </b-collapse>
            </div>
            <table
              class="table table-bordered table-striped"
              id="serverDataTable"
            >
              <thead>
                <tr>
                  <th>id</th>
                  <th>код</th>
                  <th>Название RU</th>
                  <th>Название Uz-Cyrl</th>
                  <th>Название Uz-Latn</th>
                  <th>Название Kr-Cyrl</th>
                  <th>Название Kr-Latn</th>
                  <th>Название En</th>
                  <th>Действие</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(translate, index) in translates"
                  :key="index"
                  :class="{ 'bg-warning': translate.state === 'P' }"
                >
                  <td>{{ translate.id }}</td>
                  <td>{{ translate.code }}</td>
                  <td>
                    <input-field
                      :locale="'ru'"
                      :translate_code="translate.code"
                      :translate_id="translate.id"
                      :state="translate.state"
                      @changed="addChange"
                      @sendChange="sendChange"
                      :translate="findTranslation(translate.translations, 'ru')"
                      :change="findTranslation(translate.changes, 'ru')"
                    />
                  </td>
                  <td>
                    <input-field
                      :locale="'uz-Cyrl'"
                      :translate_code="translate.code"
                      :translate_id="translate.id"
                      :state="translate.state"
                      @changed="addChange"
                      @sendChange="sendChange"
                      :translate="
                        findTranslation(translate.translations, 'uz-Cyrl')
                      "
                      :change="findTranslation(translate.changes, 'uz-Cyrl')"
                    />
                  </td>
                  <td>
                    <input-field
                      :locale="'uz-Latn'"
                      :translate_code="translate.code"
                      :translate_id="translate.id"
                      :state="translate.state"
                      @changed="addChange"
                      @sendChange="sendChange"
                      :translate="
                        findTranslation(translate.translations, 'uz-Latn')
                      "
                      :change="findTranslation(translate.changes, 'uz-Latn')"
                    />
                  </td>
                  <td>
                    <input-field
                      :locale="'kr-Cyrl'"
                      :translate_code="translate.code"
                      :translate_id="translate.id"
                      :state="translate.state"
                      @changed="addChange"
                      @sendChange="sendChange"
                      :translate="
                        findTranslation(translate.translations, 'kr-Cyrl')
                      "
                      :change="findTranslation(translate.changes, 'kr-Cyrl')"
                    />
                  </td>
                  <td>
                    <input-field
                      :locale="'kr-Latn'"
                      :translate_code="translate.code"
                      :translate_id="translate.id"
                      :state="translate.state"
                      @changed="addChange"
                      @sendChange="sendChange"
                      :translate="
                        findTranslation(translate.translations, 'kr-Latn')
                      "
                      :change="findTranslation(translate.changes, 'kr-Latn')"
                    />
                  </td>
                  <td>
                    <input-field
                      :locale="'en'"
                      :translate_code="translate.code"
                      :translate_id="translate.id"
                      :state="translate.state"
                      @changed="addChange"
                      @sendChange="sendChange"
                      :translate="findTranslation(translate.translations, 'en')"
                      :change="findTranslation(translate.changes, 'en')"
                    />
                  </td>
                  <td>
                    <!-- <a class="btn btn-warning cursor">Изменить</a> -->
                    <a
                      v-if="showChangeButton(translate.id)"
                      @click="sendChange({ id: translate.id })"
                      class="btn btn-success"
                      style="padding: 5px; margin-left: 10px"
                    >
                      <img
                        src="@/assets/icons/check-solid.svg"
                        width="10px"
                        height="10px"
                      />
                    </a>
                    <a
                      v-if="showChangeButton(translate.id)"
                      @click="cancelChange({ id: translate.id })"
                      class="btn btn-danger"
                      style="padding: 5px; margin-left: 10px"
                    >
                      <img
                        src="@/assets/icons/xmark-solid.svg"
                        width="10px"
                        height="10px"
                      />
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div style="width: 100%; display: flex; justify-content: center">
          <paginate
            style="background-color: white"
            v-model="filter.page"
            :page-count="filter.count"
            :page-range="3"
            :margin-pages="2"
            :click-handler="changePage"
            :prev-text="'<'"
            :next-text="'>'"
            :container-class="'pagination'"
            :page-class="'page-item'"
            :page-link-class="'page-link-item'"
            :prev-class="'prev-pagination'"
            :prev-link-class="'prev-link-pagination'"
            :next-class="'next-pagination'"
            :next-link-class="'next-link-pagination'"
          ></paginate>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import { RawGET, RawPOST } from "@/shared/api";
import inputField from "@/views/translations/components/inputField.vue";

export default {
  name: "Index",
  components: {
    "input-field": inputField,
  },
  data() {
    return {
      filter: {
        per_page: 10,
        page: 1,
        model: "product",
        count: 0,
        translated: 0,
        search_title: "",
        passive: 0,
        popularity: 0,
        fully_translated: 0,
        not_complete: 0,
      },
      translates: [],
      forChange: [],
    };
  },
  methods: {
    getTranslation() {
      this.forChange = [];
      this.translates = [];
      RawGET(this.filter, "/v1/translations", this, false).then((response) => {
        this.translates = response.data.data;
        this.filter.count = response.data.last_page;
      });
    },
    changePage(page) {
      this.filter.page = page;
      this.getTranslation();
    },
    changeModel(model) {
      this.filter.model = model;
      this.filter.page = 1;
      this.getTranslation();
    },
    findTranslation(translations, locale) {
      if (!Array.isArray(translations)) return null;
      return translations.find((tr) => tr.locale === locale);
    },
    addChange(change_val) {
      let { id, locale } = change_val;
      let change_index = this.forChange.findIndex(
        (change) => change.id === id && change.locale === locale
      );
      if (
        change_val.translate === true &&
        ["uz-Latn", "uz-Cyrl"].includes(change_val.locale)
      ) {
        // if latn -> translate to Cyrl, else vice verse
        let dstLocale = change_val.locale === "uz-Latn" ? "uz-Cyrl" : "uz-Latn";
        this.translate(change_val, dstLocale);
      }
      // if change empty we should push else change it

      let translate_index = this.translates.findIndex((tr) => tr.id === id);
      if (change_index === -1) {
        // add russ title and code to pretty log text
        let russo = this.translates[translate_index];
        let temp_tr = this.findTranslation(russo.translations, "ru");
        change_val.ru_title = temp_tr.title ? temp_tr.title : temp_tr.value;
        change_val.code = russo.code;

        this.forChange.push(change_val);
      } else {
        this.forChange[change_index].title = change_val.title;
      }
      // add or replace this change to for change to translate data
      let forchange_local;
      if (
        forchange_local &&
        Array.isArray(this.translates[translate_index].changes)
      ) {
        forchange_local = [...this.translates[translate_index].changes];
        // find put does this translation exist
        let locale_index = forchange_local.findIndex(
          (tr) => tr.locale === locale
        );
        if (locale_index === -1) {
          forchange_local.push(change_val);
        } else {
          forchange_local[locale_index] = change_val;
        }
      } else {
        forchange_local = [change_val];
      }
      this.$set(this.translates[translate_index], "changes", forchange_local);
    },
    cancelChange({ id, locale }) {
      let filter_;
      if (locale) {
        filter_ = (change) => change.id !== id && change.locale !== locale;
      } else {
        filter_ = (change) => change.id !== id;
      }
      this.forChange = this.forChange.filter(filter_);
      let translate_index = this.translates.findIndex((tr) => tr.id === id);
      if (translate_index !== -1) {
        let states = this.translates[translate_index].changes.map((ch) => ({
          title: "",
          locale: ch.locale,
        }));
        this.$set(this.translates[translate_index], "changes", states);
      }
    },
    sendChange({ id, locale }) {
      let filter_, rm_filter_;
      if (locale) {
        filter_ = (change) => change.id === id && change.locale === locale;
      } else {
        filter_ = (change) => change.id === id;
      }
      let changes = this.forChange.filter(filter_);
      if (changes.length === 0) return;
      RawPOST(
        { changes: changes, model: this.filter.model },
        "/v1/translations",
        this,
        true
      ).then((response) => {
        if (response.message === "success")
          //successfuly sended now we should remove applied changes in forChange
          // also add or replace to translations.translations applied changes
          changes.forEach((change) => {
            let translate_index = this.translates.findIndex(
              (tr) => tr.id === change.id
            );
            let translation_local = [
              ...this.translates[translate_index].translations,
            ];
            let tr_index = translation_local.findIndex(
              (tr) => tr.locale === change.locale
            );
            if (tr_index === -1) {
              translation_local.push(change);
            } else {
              translation_local[tr_index] = change;
            }
            this.$set(
              this.translates[translate_index],
              "translations",
              translation_local
            );
            if (locale) {
              rm_filter_ = (change) =>
                change.id === id ? change.locale !== locale : true;
            } else {
              rm_filter_ = (change) => change.id !== id;
            }
            let forchange_local = [
              ...this.translates[translate_index].changes,
            ].filter(rm_filter_);
            this.$set(
              this.translates[translate_index],
              "changes",
              forchange_local
            );
            this.forChange = this.forChange.filter(rm_filter_);
          });
      });
    },
    translate(change_val, finalLocale) {
      let variant = "";
      if (finalLocale === "uz-Cyrl") {
        variant = "2-1";
      } else if (finalLocale === "uz-Latn") {
        variant = "1-2";
      } else {
        return;
      }

      RawGET(
        { text: change_val.title, variant: variant },
        "/v1/translations/translate",
        this,
        false
      ).then((response) => {
        let translation = {
          id: change_val.id,
          locale: finalLocale,
          title: response.data.to_text.split("+").join(" "),
          code: change_val.code,
          translate: false,
        };
        this.addChange(translation);
      });
    },
    showChangeButton(id) {
      return this.forChange.find((change) => change.id === id) ? 1 : 0;
    },
  },
  mounted() {
    this.getTranslation();
  },
};
</script>
